<template>
  <div v-if="sensitiveData" class="sensitive-data">
    <span>{{sensitiveData}}</span>&nbsp;
    <i v-if="isViewPlainText" class="el-icon-view" style="cursor:pointer" @click="displaySensitiveData()" />
    <icon v-else id="icon-hide" style="cursor:pointer" @click="displaySensitiveData()"/>
  </div>
</template>

<script>
import { fetchMemberPhoneNumber } from '@/api/admin/member';
import Icon from '@/components/icon/index';

export default {
  components: {
    Icon,
  },
  props: {
    type: String, // 敏感数据类型, 暂时只有手机号
    rawData: Object, // 未敏感数据
    unionId: String, // 员工号
  },
  data() {
    return {
      sensitiveData: undefined,
      isViewPlainText: true,
      plainText: undefined, // 缓存解密后的明文
    }
  },
  created() {
    this.sensitiveData = this.rawData;
  },
  watch: {
    rawData(val) {
      this.sensitiveData = val;
    }
  },
  methods: {
    displaySensitiveData() {
      if ('phoneNumber' === this.type) {
        if (this.isViewPlainText) {
          if (!this.plainText) {
            fetchMemberPhoneNumber(this.unionId).then(response => {
              this.sensitiveData = response.data.data;
              this.plainText = this.sensitiveData;
              this.isViewPlainText = false;
            });
          } else {
            this.sensitiveData = this.plainText;
            this.isViewPlainText = false;
          }
        } else {
          const phoneNumber = this.sensitiveData;
          this.sensitiveData = phoneNumber.length > 7
                // 前三后四
                ? phoneNumber.substring(0, 3) + "****" + phoneNumber.substring(phoneNumber.length - 4)
                : phoneNumber;
          this.isViewPlainText = true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .sensitive-data {
    display: flex;
    align-items: center;
    i {
      position: relative;
      top: -1px;
    }
  }
</style>
